import { IAutomationObject } from '../../types'

export interface IMultisensor extends IAutomationObject {
    presence: boolean;
    presenceOffDelay: number;
    brightness: number;

    onValueChanged: any;

}

export const schema = 'AutomationApps.Devices.Switches.Multisensor';